import { Component } from '@theme/component';
import { SlideshowSelectEvent } from '@theme/events';
import { StandardEvents } from '@shopify/events';

/** @extends {Component<{counter: HTMLElement}>} */
class VVProductGallery extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(SlideshowSelectEvent.eventName, this.handleSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(SlideshowSelectEvent.eventName, this.handleSelect);
  }
  /** @param {Event & {detail?: {index?: number}}} event */
  handleSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('zoom-dialog')) return;
    if (Number.isInteger(event.detail?.index) && this.refs.counter) {
      this.refs.counter.textContent = String(event.detail.index + 1);
    }
  };
}

/** @extends {Component<{content: HTMLElement}>} */
class VVProductFacts extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section')?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }
  /** @param {Event & {promise?: Promise<{detail?: {html?: Document, productId?: string, newProduct?: boolean}}>}} event */
  handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    try {
      const result = await event.promise;
      const detail = result?.detail;
      if (!this.isConnected || !detail?.html || !this.dataset.blockId) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector('vv-product-facts[data-block-id="' + CSS.escape(this.dataset.blockId) + '"] [ref="content"]');
      if (next && this.refs.content) this.refs.content.replaceChildren(...Array.from(next.childNodes, node => node.cloneNode(true)));
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[vv-product-facts] Could not update lot details.', error);
    }
  };
}
if (!customElements.get('vv-product-gallery')) customElements.define('vv-product-gallery', VVProductGallery);
if (!customElements.get('vv-product-facts')) customElements.define('vv-product-facts', VVProductFacts);

